export default __webpack_public_path__ + "static/media/cart.3c462815.svg";